import './menu/top-menu';
import './gallery/gallery';

console.info("Change for once!");